import {button,escapeHtml} from '../ui/components.js';
import {tastePreferenceDefinitions} from './taste-preference-catalogue.js';
import {createTastePreferences} from './taste-preferences.js';

export function tastePreferencesMarkup(preferences={}, {locale='pl'}={}){
  const values=createTastePreferences(preferences);
  const fields=tastePreferenceDefinitions({locale}).map(def=>{
    const selected=values[def.key]||'';
    const options=['<option value="">Bez preferencji</option>']
      .concat(def.options.map(option=>'<option value="'+escapeHtml(option.value)+'"'+(option.value===selected?' selected':'')+'>'+escapeHtml(option.label)+'</option>'))
      .join('');
    return '<label class="field" for="taste-'+escapeHtml(def.key)+'"><span class="field-label">'+escapeHtml(def.label)+'</span><select id="taste-'+escapeHtml(def.key)+'" name="'+escapeHtml(def.key)+'">'+options+'</select></label>';
  }).join('');

  return '<form id="taste-preferences-form" class="taste-preferences-form"><div class="onboarding-copy"><h2>Preferencje smaku</h2><p>Te ustawienia służą wyłącznie do personalizacji podpowiedzi. Nie zmieniają reguł bezpieczeństwa żywności.</p></div><div class="form-grid">'+fields+'</div><div class="actions">'+button({id:'save-taste-preferences',label:'Zapisz preferencje',type:'submit'})+'</div></form>';
}
